import React from "react";
import "./Hero.scss";

const Hero = () => {
  return (
    <section className="hero" id="inicio">
      <div className="hero__overlay"></div>

      <div className="hero__container">
        <div className="hero__content">
          <span className="hero__tag">
            Vidrio y aluminio en CDMX y Área Metropolitana
          </span>

          <h1 className="hero__title">
            Soluciones en vidrio y aluminio para proyectos residenciales y
            comerciales
          </h1>

          <p className="hero__description">
            En Yare And San Industry desarrollamos canceles, ventanas, puertas,
            barandales, divisiones para oficina y proyectos en cristal templado
            con acabados profesionales, diseño funcional y atención
            personalizada.
          </p>

          <div className="hero__buttons">
            <a
              href="https://wa.me/525566176657"
              target="_blank"
              rel="noreferrer"
              className="hero__btn hero__btn--primary"
            >
              Cotizar por WhatsApp
            </a>

            <a href="#proyectos" className="hero__btn hero__btn--secondary">
              Ver proyectos
            </a>
          </div>

          <div className="hero__stats">
            <div className="hero__stat">
              <h3>10+</h3>
              <p>Años de experiencia</p>
            </div>

            <div className="hero__stat">
              <h3>500+</h3>
              <p>Instalaciones realizadas</p>
            </div>

            <div className="hero__stat">
              <h3>200+</h3>
              <p>Clientes satisfechos</p>
            </div>
          </div>
        </div>

        <div className="hero__side">
          <div className="hero__card">
            <h2>Especialistas en cristal templado</h2>
            <p>
              Trabajamos proyectos para casas, departamentos, oficinas, locales
              comerciales y espacios corporativos, cuidando diseño, resistencia
              y presentación final.
            </p>

            <ul>
              <li>Canceles de baño</li>
              <li>Barandales de vidrio</li>
              <li>Puertas y ventanas de aluminio</li>
              <li>Divisiones para oficina</li>
              <li>Proyectos especiales</li>
            </ul>
          </div>
        </div>
      </div><br/><br/>
    </section>
  );
};

export default Hero;